import flagus from "../assets/images/flags/us.svg";
import flagid from "../assets/images/flags/id.svg";

const languages = {
  id: {
    label: "Bahasa",
    flag: flagid,
  },
  en: {
    label: "English",
    flag: flagus,
  }
}

export default languages
